// apps/lc/src/mocks/wireframe/textbooks.ts
import type { Textbook, Curriculum } from './types'

const curr: Curriculum[] = ['core-a', 'core-b', 'core-c', 'prime-a', 'prime-b', 'prime-c']

export const TEXTBOOKS: Textbook[] = [
  ...curr.flatMap<Textbook>((c, i) =>
    [1, 2, 3].map(ch => ({
      id: `tb-checkup-${c}-${ch}`,
      kind: 'checkup' as const,
      curriculum: c,
      chapterOrVolume: `챕터 ${ch}`,
      coverImage: null,
      description: `${c.toUpperCase()} 챕터 ${ch} 체크업북. 학습한 챕터를 인쇄물로 확인합니다.`,
      price: 8000 + i * 500,
      sampleUrl: null,
    }))
  ),
  ...curr.flatMap<Textbook>((c, i) =>
    [1, 2].map(v => ({
      id: `tb-workbook-${c}-${v}`,
      kind: 'workbook' as const,
      curriculum: c,
      chapterOrVolume: `${v}권`,
      coverImage: null,
      description: `${c.toUpperCase()} ${v}권 워크북. 반복 학습용 인쇄물입니다.`,
      price: 12000 + i * 500,
      sampleUrl: null,
    }))
  ),
]
